<template>
  <div class="color-toolbar">
    <div class="icon-color" ref="btn-panel">
      <ms-button
        type="secondary-outline"
        class="toolbar-workbook-button"
        :title="propsData.toolTip"
        :left-icon="propsData.icon || ''"
        @click="() => {showHideColor = !showHideColor}"    
      />
    </div>
    <div ref="setting-panel" class="color">
      <color-picker
        v-model:pureColor="colorValue"
        @pureColorChange="pickColor"
        format="hex6"
        :is-widget="true"
        v-if="showHideColor"
      />
    </div>
  </div>
</template>

<script>
import {ColorPicker} from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import {defineComponent, getCurrentInstance, onMounted, computed, nextTick, watch, onBeforeUnmount} from 'vue';
import commonFn from '@/commons/commonFunction.js';
import {ref, toRef} from 'vue';

export default {
  name: 'toolbarItemButton',
  components: {
    ColorPicker,
  },
  props: {
    propsData: {
      type: Object,
      default: {},
    },
  },
  emits: ['toolbarEvent'],
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const showHideColor = ref(false);
    const colorValue = ref();

    onMounted(() => {
      const me = proxy;
      document.addEventListener('click', me.clickOut);
    });

    onBeforeUnmount(() => {
      const me = proxy;
      document.removeEventListener('click', me.clickOut);
    });

    /**
     * Sự kiện clikc ra ngoài để ẩn color picker
     */
    function clickOut(e) {
      const me = proxy;
      if (
        !commonFn.hasParent(e.target, me.$refs['setting-panel']) &&
        !commonFn.hasParent(e.target, me.$refs['btn-panel'])
      ) {
        me.showHideColor = false;
      }
    }
    const pickColor = color => {
      emit('toolbarEvent', event, 'pickColor', {toolbar: props.propsData, value: color});
    };   
   
    return {
      pickColor,
      clickOut,
      showHideColor,
    };
  },
};
</script>

<style lang="scss" scoped>
.color-toolbar {
  position: relative;
  .color {
    position: absolute;
  }
}
</style>
